(function ($) {
  'use strict';
  $(function () {
    $(document).on('click', '.fit_act', function () {
      $(this).toggleClass('fit_opened')
    });
  });
})(jQuery);
